
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-benefit/free-facility/[companyname]",
      function () {
        return require("private-next-pages/free-benefit/free-facility/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-benefit/free-facility/[companyname]"])
      });
    }
  